import { useEffect, useState } from 'react'

export interface CountdownParts {
  hours: string
  minutes: string
  seconds: string
  isFinished: boolean
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

export function useCountdown(totalHours: number): CountdownParts {
  const totalSeconds = Math.round(totalHours * 3600)
  const [remaining, setRemaining] = useState<number>(totalSeconds)

  useEffect(() => {
    setRemaining(totalSeconds)
  }, [totalSeconds])

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
    isFinished: remaining <= 0,
  }
}
